var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app-center" },
    [
      _vm._m(0),
      _c("div", { staticClass: "content v-page-center div-center flex" }, [
        _c(
          "div",
          { staticClass: "nav-list flex-auto" },
          _vm._l(_vm.navs, function (app, idx) {
            return _c(
              "div",
              {
                key: app.id,
                staticClass: "app-item text-center",
                class: [_vm.currIdx === idx ? "active" : ""],
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "pointer",
                    on: {
                      click: function ($event) {
                        return _vm.handleTextClick(app, idx)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(app.name) + " ")]
                ),
              ]
            )
          }),
          0
        ),
        _c(
          "div",
          { staticClass: "cards" },
          [
            _c(
              "a-spin",
              {
                staticStyle: { height: "100%" },
                attrs: { spinning: _vm.loading },
              },
              [
                _vm.appList.length
                  ? [
                      _c(
                        "div",
                        { staticClass: "cards-section flex-wrap" },
                        _vm._l(_vm.appList, function (app) {
                          return _c(
                            "div",
                            {
                              key: app.appId,
                              staticClass:
                                "card-item pointer flex-column flex-side-center",
                              on: {
                                click: function ($event) {
                                  return _vm.toDetailPage(app)
                                },
                              },
                            },
                            [
                              _c("img", {
                                staticClass: "icon",
                                attrs: { src: _vm.appUrl(app), alt: app.name },
                              }),
                              _c("span", { staticClass: "text" }, [
                                _vm._v(_vm._s(app.name)),
                              ]),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  : [
                      _c(
                        "div",
                        {
                          staticClass: "flex-center",
                          staticStyle: { height: "300px" },
                        },
                        [
                          _c("a-empty", {
                            attrs: {
                              image: _vm.Empty.PRESENTED_IMAGE_SIMPLE,
                              description: "暂无数据",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                _c("a-icon", {
                  staticStyle: { "font-size": "32px" },
                  attrs: { slot: "indicator", type: "loading", spin: "" },
                  slot: "indicator",
                }),
              ],
              2
            ),
          ],
          1
        ),
      ]),
      _c("AppDetail", { ref: "appDetailRef" }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "banner" }, [
      _c("div", { staticClass: "v-page-center div-center text-center" }, [
        _c("div", { staticClass: "title" }, [_vm._v("查看我们支持的应用系统")]),
        _c("div", { staticClass: "sub-title" }, [
          _c("div", [
            _vm._v(
              " 截止目前，我们与32家供应商进行深入合作，接入100+款设备，每年为5万个家庭提供各项服务并在持续丰富我们的产品。 "
            ),
          ]),
          _c("div", [
            _vm._v(
              "我们也支持集成您的自有设备，如需合作请通过页面底部的联系方式与我们取得联系。"
            ),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }